import {apiHelper} from "../redux/apiHelper"
export const getCmsServiceSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-service-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsServiceSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-service-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsServiceSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-service-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsServiceSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-service-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsServiceSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-service-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}